import { PermissionActions } from '@/features/permissions/permissionActions.js'

export const superAdminLogsNavigationItems = Object.freeze([
  {
    label: 'Mobile Profile List',
    sidebarLabel: 'sidebar.logsSub.mobileProfileList',
    value: 'mobileProfileList',
    iconClass: 'pi pi-mobile',
    permissionAction: PermissionActions.SuperAdminLimitedLogsMobileProfileListView,
  },
  {
    label: 'Mobile Access Tenants',
    sidebarLabel: 'sidebar.logsSub.mobileTenantList',
    value: 'mobileTenantList',
    iconClass: 'pi pi-building',
    permissionAction: PermissionActions.SuperAdminLimitedLogsMobileTenantListView,
  },
  {
    label: 'Notification',
    sidebarLabel: 'sidebar.logsSub.notification',
    value: 'notification',
    iconClass: 'pi pi-bell',
    permissionAction: PermissionActions.SuperAdminLimitedLogsNotificationsView,
  },
  {
    label: 'Chat Entry Records',
    sidebarLabel: 'sidebar.logsSub.chatEntryRecords',
    value: 'notificationGetStartChatRecordList',
    iconClass: 'pi pi-comments',
    permissionAction: PermissionActions.SuperAdminLimitedLogsStartChatRecordsView,
  },
  {
    label: 'Chat Sent Records',
    sidebarLabel: 'sidebar.logsSub.chatSentRecords',
    value: 'notificationGetChatRecordList',
    iconClass: 'pi pi-send',
    permissionAction: PermissionActions.SuperAdminLimitedLogsChatRecordsView,
  },
  {
    label: 'Error Logs',
    sidebarLabel: 'sidebar.logsSub.errorLogs',
    value: 'errorLogs',
    iconClass: 'pi pi-exclamation-triangle',
    permissionAction: PermissionActions.SuperAdminLimitedLogsErrorLogsView,
  },
  {
    label: 'Audit Logs',
    sidebarLabel: 'sidebar.logsSub.auditLogs',
    value: 'auditLogs',
    iconClass: 'pi pi-history',
    permissionAction: PermissionActions.SuperAdminLimitedLogsAuditView,
  },
])

export const SuperAdminLimitedLogsViewActions = Object.freeze(
  superAdminLogsNavigationItems.map(item => item.permissionAction),
)

export const superAdminLogsSidebarChildren = Object.freeze(
  superAdminLogsNavigationItems.map(item => ({
    label: item.sidebarLabel,
    iconClass: item.iconClass,
    to: {
      path: '/super-admin/logs',
      query: {
        tab: item.value,
      },
    },
    permissionAction: item.permissionAction,
  })),
)
